export default "__VITE_ASSET__BxCswS8M__"